import { Injectable } from '@angular/core';
import {ApiService, EnvironmentModel} from '@cas-hub/acabim-common-client';
import {HttpClient, HttpParams} from '@angular/common/http';
import {FinancialInventory, LineItem, LineItemRequest} from '../_models/financial-inventory.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FinancialInventoryService extends ApiService {

  constructor(protected client: HttpClient, protected environment: EnvironmentModel) {
    super(client, environment);
  }

  protected controller = 'financial/inventory';

  public getInventory(
      first: number = 1,
      length: number = 25,
      sortOrder: number = 1,
      sortField?: string,
      filters?: { objectPropertyName: string, value: string }[]
  ): Observable<FinancialInventory> {
    let params = new HttpParams()
        .set('pageSize', String(length))
        .set('pageNumber', String(Math.floor(first / length) + 1));
    if (sortField) {
      const sortOrderString = sortOrder === 1 ? 'ascending' : 'descending';
      params = params.append('sort', sortField);
      params = params.append('sortDirection', sortOrderString);
    }
    filters?.forEach(filter => params = params.set(filter.objectPropertyName, filter.value));
    return this.client.get(this.url(''), {
      params,
      headers: this.defaultHeaders,
      responseType: 'json'
    }).pipe(map(data => (data as FinancialInventory)));
  }

  public getInventoryItem(itemId: number): Observable<LineItem> {
    return this.client.get(this.url('' + itemId.toString())).pipe(map(data => (data as LineItem)))
  }

  public updateInventoryItem(itemId: number, parcel: LineItemRequest): Observable<LineItem> {
    return this.client.post(this.url('' + itemId.toString()), parcel).pipe(map(data => (data as LineItem)))
  }

  public addInventory(parcel: LineItemRequest): Observable<LineItem> {
    return this.client.post(this.url(''), parcel).pipe(map(data => (data as LineItem)))
  }
}
